// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "groupTitle-3xbw_";
export { _1 as "__esModule", _2 as "groupTitle" }
export default { "__esModule": _1, "groupTitle": _2 }
